import classnames from 'classnames'
import parse from 'html-react-parser'
import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { ConversationCardFiles } from 'entities/Conversation/ui/ConversationCard'
import { getAttachmentType } from 'entities/Attachment'
import { type MessageFieldStore } from 'widgets/MessageField'
import styles from './styles.module.scss'

export const MessageFieldNodeContent = observer(
  ({ messageFieldStore }: { messageFieldStore: MessageFieldStore }) => {
    const attachments = messageFieldStore.attachments
    const attachmentsCount = attachments.length

    const messageHtml = messageFieldStore.messageHtml

    return messageHtml ? (
      <div className={styles.wrap}>
        {!!attachmentsCount && (
          <ConversationCardFiles
            type={getAttachmentType({
              content_type: attachments[0]?.type || '',
            })}
            count={attachmentsCount}
            isShowCount={attachmentsCount > 1}
            isHideIcon={attachmentsCount > 1}
          />
        )}
        {messageHtml && (
          <Typography
            variant={'body-md-regular'}
            className={classnames(styles.text)}
            ariaLabel={'text'}
          >
            {parse(messageHtml)}
          </Typography>
        )}
      </div>
    ) : null
  }
)
